/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderStatus {
    DRAFT = 'Draft',
    SUBMITTED = 'Submitted',
    DEPOSIT_TAKEN = 'DepositTaken',
    HOLD_TAKEN = 'HoldTaken',
    PART_ALLOCATED = 'PartAllocated',
    ALLOCATED = 'Allocated',
    PAYMENT_PENDING = 'PaymentPending',
    PAYMENT_FAILED = 'PaymentFailed',
    PARTIAL_PAYMENT = 'PartialPayment',
    PAID_IN_FULL = 'PaidInFull',
    PARTIAL_FULFILLMENT = 'PartialFulfillment',
    FULFILLED = 'Fulfilled',
    CANCEL_PENDING = 'CancelPending',
    CANCELED = 'Canceled',
}
